import React, { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import tableState from "./state";
export function SetTableErrors({
  val,
  error,
  machineName,
  rowIndex,
  columnId,
}) {
  const setErrors = useSetRecoilState(tableState);
  useEffect(() => {
    let newTableErrors;
    if (error) {
      setErrors((errors) => {
        newTableErrors = JSON.parse(JSON.stringify(errors));
        !(machineName in newTableErrors) &&
          (newTableErrors[`${machineName}`] = {});
        // rowKey exists? if not create it
        !(rowIndex in newTableErrors[`${machineName}`]) &&
          (newTableErrors[`${machineName}`][`${rowIndex}`] = []);
        // item in array exists? if not push it
        !newTableErrors[`${machineName}`][`${rowIndex}`].includes(columnId) &&
          newTableErrors[`${machineName}`][`${rowIndex}`].push(columnId);
        return newTableErrors;
      });
    } else {
      if (val) {
        setErrors((errors) => {
          newTableErrors = JSON.parse(JSON.stringify(errors));
          let rowArray = errors?.[`${machineName}`]?.[`${rowIndex}`]
            ? [...errors?.[`${machineName}`]?.[`${rowIndex}`]]
            : null;

          if (rowArray) {
            let newRowArray = rowArray.filter((error) => error !== columnId);
            newTableErrors[`${machineName}`][`${rowIndex}`] = newRowArray;
          }
          return newTableErrors;
        });
      }
    }
  }, [rowIndex]);
  return <div></div>;
}

/**
 * Because errors are not automatically generated if there are multiple pages on a table, we must loop
 * through the entire dataset to check whether or not there are any missing or malformed fields.
 */

export const buildAllTableErrors = (data, machine_name, formData) => {
  return (
    data &&
    data.map((item, index) => {
      let error = null;
      const requiredFields = [
        "apdxaCity",
        "apdxaState",
        "apdxaCounty",
        "apdxaMsa",
      ];
      // const dateFields = ["apdxaBeginDate", "apdxaEndDate"];
      const emptyValues = ["", "- Select -", undefined, null];
      let row = Object.entries(item).map(([key, value]) => {
        error = null;
        if (requiredFields.includes(key)) {
          if (emptyValues.includes(value)) {
            error = "This field is required.";
          }
        }
        // if (dateFields.includes(key) && value && formData && formData.b5_begin_date && formData.b6_end_date) {
        //   const day = new Date(value);
        //   const { b5_begin_date, b6_end_date } = formData;
        //   if (key == "apdxaBeginDate") {
        //     if (day && b6_end_date && day.getTime() > new Date(b6_end_date).getTime()) {
        //       error = "Please select a date that is less than or equal to the end date entered in section B.";
        //     }
        //     if (day && b5_begin_date && day.getTime() < new Date(b5_begin_date).getTime()) {
        //       console.log("should error here");
        //       error = "Please select a date that is greater than or equal to the begin date entered in section B.";
        //     }
        //   }
        //   if (key == "apdxaEndDate") {
        //     if (day && b5_begin_date && day.getTime() < new Date(b5_begin_date).getTime()) {
        //       error = "Please select a date that is greater than or equal to the begin date entered in section B.";
        //     }
        //     if (day && b6_end_date && day.getTime() > new Date(b6_end_date).getTime()) {
        //       error = "Please select a date that is less than or equal to the end date entered in section B.";
        //     }
        //   }
        // }
        return (
          <SetTableErrors
            val={value}
            error={error}
            machineName={machine_name}
            rowIndex={index}
            columnId={key}
          />
        );
      });
      return row;
    })
  );
};
export const removeRowFromTableErrors = (rowIndex, machine_name) => {
  const rowFields = [
    "apdxaCity",
    "apdxaState",
    "apdxaCounty",
    "apdxaMsa",
    "apdxaBeginDate",
    "apdxaEndDate",
    "apdxaWageFrom",
    "apdxaWageTo",
    "apdxaWagePer",
    "apdxaTotalWorkers",
    "apdxaCrewId",
    "apdxaAddlInfo",
  ];
  return rowFields.map((columnId) => {
    return (
      <SetTableErrors
        val={"remove"}
        error={null}
        machineName={machine_name}
        rowIndex={rowIndex}
        columnId={columnId}
      />
    );
  });
};
